export const pluralize = (
  phrase: string,
  count: number,
  withoutCount: boolean = false,
) => {
  const rules = {
    '([^aeiouy]|qu)y$': '$1ies',
    '(x|ch|ss|sh)$': '$1es',
    '([^s]+)$': '$1s',
    was: 'were',
    is: 'are',
    country: 'countries',
  }

  if (count === 1) {
    return `${withoutCount ? '' : `${count} `}${phrase}`
  }

  const rule = Object.entries(rules).find(([key]) => new RegExp(key, 'i').test(phrase))
  const newPhrase = rule ? phrase.replace(new RegExp(rule[0], 'i'), rule[1]) : phrase

  return `${withoutCount ? '' : `${count} `}${newPhrase}`
}
